import { render, staticRenderFns } from "./ReviewSlide.vue?vue&type=template&id=5d358cd0&"
import script from "./ReviewSlide.vue?vue&type=script&lang=js&"
export * from "./ReviewSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports